import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotMovies from './components/HotMovies';
import LatestMovies from './components/LatestMovies';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '天美影视 - 天美影视电影大全，最新电影高清免费在线观看',
    description: '天美影视电影大全，最新电影高清免费在线观看，不缓冲流畅追大片，免费在线看电影，高清电影大全在线看。',
    url: 'https://www.tianmeiying.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '天美影视',
      url: 'https://www.tianmeiying.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '天美影视的电影需要付费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全不需要。天美影视所有电影资源均为免费在线观看，无需注册会员，无需支付任何费用。',
        },
      },
      {
        '@type': 'Question',
        name: '看电影会卡顿吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '天美影视采用全球CDN加速技术，确保高清画质流畅播放，不缓冲不卡顿，为您带来极致的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '天美影视全面支持电脑、平板、手机等所有设备，随时随地享受高清电影在线观看的乐趣。',
        },
      },
      {
        '@type': 'Question',
        name: '电影资源更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们每日更新最新电影资源，确保您第一时间观看到最新上映的热门大片，电影大全时刻保持新鲜。',
        },
      },
    ],
  };

  return (
    <>
      <SchemaOrg data={webPageSchema} />
      <SchemaOrg data={faqSchema} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <div className="bg-background-200 py-10 md:py-14 space-y-12 md:space-y-16">
            <CategoryNav />
            <HotMovies />
            <LatestMovies />

            <section className="w-full px-4 md:px-6">
              <div className="max-w-[1200px] mx-auto">
                <div className="rounded-2xl bg-gradient-to-r from-background-700/60 to-background-600/40 border border-background-600/40 p-8 md:p-12 text-center animate-fade-in-up animation-fill-both">
                  <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-4">
                    为什么选择<strong>天美影视</strong>？
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
                    <div className="flex flex-col items-center gap-3 p-4">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/10">
                        <i className="ri-speed-up-line text-2xl text-primary-400"></i>
                      </div>
                      <h3 className="text-base font-heading font-semibold text-foreground-200">流畅不缓冲</h3>
                      <p className="text-sm text-foreground-500">全球CDN加速，高清画质秒加载，告别卡顿</p>
                    </div>
                    <div className="flex flex-col items-center gap-3 p-4">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/10">
                        <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                      </div>
                      <h3 className="text-base font-heading font-semibold text-foreground-200">海量片库</h3>
                      <p className="text-sm text-foreground-500">覆盖动作、喜剧、科幻等十大类型，每日更新</p>
                    </div>
                    <div className="flex flex-col items-center gap-3 p-4">
                      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/10">
                        <i className="ri-shield-check-line text-2xl text-primary-400"></i>
                      </div>
                      <h3 className="text-base font-heading font-semibold text-foreground-200">完全免费</h3>
                      <p className="text-sm text-foreground-500">无需注册，无需付费，高清电影免费在线看</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full px-4 md:px-6">
              <div className="max-w-[1200px] mx-auto">
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mb-6">
                  <a href="#faq">常见问题</a>
                </h2>
                <div className="space-y-3">
                  {[
                    { q: '天美影视的电影需要付费吗？', a: '完全不需要。天美影视所有电影资源均为免费在线观看，无需注册会员，无需支付任何费用。' },
                    { q: '看电影会卡顿吗？', a: '天美影视采用全球CDN加速技术，确保高清画质流畅播放，不缓冲不卡顿，为您带来极致的观影体验。' },
                    { q: '支持哪些设备观看？', a: '天美影视全面支持电脑、平板、手机等所有设备，随时随地享受高清电影在线观看的乐趣。' },
                    { q: '电影资源更新频率如何？', a: '我们每日更新最新电影资源，确保您第一时间观看到最新上映的热门大片，电影大全时刻保持新鲜。' },
                  ].map((faq, i) => (
                    <details key={i} className="group rounded-xl bg-background-700/40 border border-background-700/40 overflow-hidden animate-fade-in-up animation-fill-both" style={{ animationDelay: `${i * 0.1}s` }}>
                      <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer text-sm md:text-base font-medium text-foreground-200">
                        {faq.q}
                        <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform duration-300"></i>
                      </summary>
                      <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-500 leading-relaxed">
                        {faq.a}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}